<main *ngIf="!isOpenModal" class="main-container">

    <!-- عنوان صفحه -->

    <div class="bg-th-yellow mt-0 container-fluid">

        <div class=" d-flex justify-content-between align-content-center h-35">
      
          <i class="fa fa-arrow-left text-dark my-auto pointer" routerLink="/"></i>
      
          <span class="my-auto f16 fw-bold me-2">

            <ng-container *ngIf="bEmdadran;else bTaxi">

                مدیریت درخواست ها

            </ng-container>

            <ng-template #bTaxi>

                مدیریت تاکسی {{ isCity ? '' : 'بین' }} شهری 

            </ng-template>
        
        </span>
      
        </div>
      
    </div>

    <!-- جدول اطلاعات  -->
    
    <section class="w-100 row gx-0 gy-0 p-2" style="direction: rtl;">

        <ul class="col-12 py-2 nav nav-pills">

            <ng-container *ngIf="mdl_Search.get('tiTripStatus')?.value as tiTripStatus">

                <!-- درخواست های جدید -->

                <li class="nav-item" (click)="tabSwitch(1)">

                    <a class="nav-link" [ngClass]="tiTripStatus == 1 ? 'active text-white' : 'text-muted'"> درخواست های جدید </a>

                </li>

                <!-- در انتظار شروع -->

                <li class="nav-item" (click)="tabSwitch(4)">

                    <a class="nav-link" [ngClass]="tiTripStatus == 4 ? 'active text-white' : 'text-muted'"> در انتظار شروع </a>

                </li>

                <!-- در حال اجرا -->

                <li class="nav-item" (click)="tabSwitch(5)">

                    <a class="nav-link" [ngClass]="tiTripStatus == 5 ? 'active text-white' : 'text-muted'"> درحال اجرا </a>

                </li>

                <!-- لغو شده توسط مسافر -->

                <li *ngIf="!bEmdadran" class="nav-item" (click)="tabSwitch(10)">

                    <a class="nav-link" [ngClass]="tiTripStatus == 10 ? 'active text-white' : 'text-muted'"> لغو شده توسط مسافر </a>

                </li>

            </ng-container>

        </ul>

        <div class="col-12 row gx-0 gx-1 gy-2 gy-md-2 border border-2 mt-2 p-2">

            <!-- افزودن درخواست جدید -->

            <ng-container *ngIf="mdl_Search.get('tiTripStatus')?.value as tiTripStatus">

                <ng-container *ngIf="tiTripStatus != 1;else notNewReq">

                    <div class="col-12">

                        <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." (input)="filter_Result($event.target.value)">
        
                    </div>

                </ng-container>

                <ng-template #notNewReq>

                    <div class="col-12 col-md-9">
                        
                        <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." (input)="filter_Result($event.target.value)">

                    </div>

                    <div class="col-12 col-md-auto px-2">

                        <button class="btn btn-success w-100" (click)="newRequest()"> 
                        
                            &nbsp; افزودن &nbsp;

                        </button>

                    </div>

                    <div class="col-12 col-md-auto">

                        <button class="btn btn-warning w-100" (click)="showMap_Cluster()"> 
                        
                            &nbsp; نقشه &nbsp;

                        </button>

                    </div>
    
                </ng-template>

            </ng-container>
   
            <div class="col-12 section border border-2 mt-2" style="height:calc(100vh - 200px);overflow: auto;">
    
                <table class="col-12 table table-striped rounded-3" id="Export_Excel">
    
                    <thead class="">

                        <ng-container *ngIf="mdl_Search.get('tiTripStatus')?.value as tiTripStatus">
        
                            <tr class="">

                                <!-- درخواست های جدید -->

                                <ng-container *ngIf="tiTripStatus == 1">
        
                                    <th class="text-center col-1"> # </th>
            
                                    <th class="text-center"> عملیات </th>
            
                                    <th class="text-center"> {{ bEmdadran ? 'کد درخواست' : 'کد سفر' }} </th>

                                    <th class="text-center"> وضعیت </th>
            
                                    <th class="text-center"> تاریخ ثبت </th>
                                    
                                    <th class="text-center"> ساعت ثبت </th>

                                    <th *ngIf="!bEmdadran" class="text-center"> {{ bEmdadran ? 'تاریخ درخواست' : 'تاریخ سفر' }} </th>
                                    
                                    <th *ngIf="!bEmdadran" class="text-center"> {{ bEmdadran ? 'ساعت درخواست' : 'ساعت سفر' }}  </th>
            
                                    <th class="text-center"> {{ bEmdadran ? 'گروه امدادی' : 'گروه خودرویی' }} </th>
            
                                    <th class="text-center"> {{ col_strSource }} </th>
            
                                    <th class="text-center"> {{ col_strDestination }} </th>

                                    <th *ngIf="!bEmdadran" class="text-center"> مبلغ کرایه(ریال) </th>

                                </ng-container>

                                <!--در انتظار شروع, در حال اجرا -->

                                <ng-container *ngIf="tiTripStatus == 4 || tiTripStatus == 5">
        
                                    <th class="text-center col-1"> # </th>
            
                                    <th class="text-center"> عملیات </th>
            
                                    <th class="text-center"> {{ bEmdadran ? 'کد درخواست' : 'کد سفر' }} </th>

                                    <th *ngIf="!bEmdadran" class="text-center"> وضعیت </th>
            
                                    <th class="text-center"> {{ bEmdadran ? 'امدادگر' : 'راننده' }} </th>
                                    
                                    <th class="text-center"> موبایل </th>
            
                                    <th class="text-center">{{ bEmdadran ? 'تاریخ' : 'تاریخ سفر' }} </th>
                                    
                                    <th class="text-center"> {{ bEmdadran ? 'ساعت' : 'ساعت سفر' }}  </th>
            
                                    <th class="text-center"> {{ col_strSource }} </th>
            
                                    <th class="text-center"> {{ col_strDestination }} </th>

                                    <th class="text-center"  *ngIf="bEmdadran"> {{ bEmdadran ? 'گروه امدادی' : 'گروه خودرویی' }} </th>

                                    <th class="text-center"  *ngIf="!bEmdadran"> مبلغ کرایه(ریال) </th>

                                    <th class="text-center" *ngIf="tiTripStatus == 5"> وضعیت </th>

                                </ng-container>
                                
                                <!-- لغو شده توسط مسافر -->

                                <ng-container *ngIf="tiTripStatus == 10">
        
                                    <th class="text-center col-1"> # </th>
            
                                    <th class="text-center"> عملیات </th>
            
                                    <th class="text-center"> کد سفر </th>

                                    <th class="text-center"> وضعیت </th>
            
                                    <th class="text-center"> نام, نام خانوادگی </th>

                                    <th class="text-center"> مبلغ کرایه(ریال) </th>

                                </ng-container>

                            </tr>

                        </ng-container>
    
                    </thead>
    
                    <tbody class="">
    
                        <tr class="col-12 text-center" *ngFor="let item of lst_Requests;let i = index">

                            <ng-container *ngIf="mdl_Search.get('tiTripStatus')?.value as tiTripStatus">

                                <!-- درخواست های جدید -->

                                <ng-container *ngIf="tiTripStatus == 1">

                                    <td>{{ i + 1 | faNum }}</td>

                                    <td class="">

                                        <i class="fa fa-info-circle fa-lg pointer" (click)="newRequest(item,i,'showMode')"></i>

                                        <i class="fa fa-pencil-square fa-lg mx-2 pointer" title="ویرایش" (click)="newRequest(item,i)"></i>

                                        <i class="fa fa-window-close fa-lg pointer" [title]="bEmdadran ? 'لغو' : 'لغو سفر' " (click)="cancelRequest(item,i)"></i>

                                        <i class="fa fa-id-card-o fa-lg mx-2 pointer" title="وضعیت دریافت پیشنهاد" (click)="suggestion_Status(item)"></i>

                                        <i class="fa fa-map-pin fa-lg pointer" [title]="bEmdadran ? 'موقعیت امدادگر' : 'موقعیت' "></i>

                                        <i class="fa fa-car fa-lg mx-2 text-muted pointer" title="اختصاص خودرو بر اساس وضعیت" (click)="open_AssignModal_2(bEmdadran ? item.iEmdadRo : item.iTaxiLon_Trip)"></i>

                                        <i *ngIf="false" class="fa fa-car fa-lg mx-2 text-primary pointer" title="اختصاص براساس برنامه" (click)="open_AssignModal(bEmdadran ? item.iEmdadRo : item.iTaxiLon_Trip)"></i>

                                        <i class="fa fa-car fa-lg text-success pointer" [title]="bEmdadran ? 'امدادگران رزرو' : 'رانندگان رزرو' " (click)="open_AssignModal_2(bEmdadran ? item.iEmdadRo : item.iTaxiLon_Trip,true)"></i>

                                    </td>
        
                                    <td> {{ (bEmdadran ? item.iEmdadRo : item.iTaxiLon_Trip) | faNum }} </td>
        
                                    <td> {{ item.strTaxiLon_TripStatus_strComment | faNum }} </td>
        
                                    <td> {{ item.strSaveFullTime?.split(' ')[0] | faNum }} </td>
                                    
                                    <td> {{ item.strSaveFullTime?.split(' ')[1] | faNum }} </td>
                                    
                                    <td *ngIf="!bEmdadran"> {{ item.strDate | faNum }} </td>
                                    
                                    <td *ngIf="!bEmdadran"> {{ item.strTime | faNum }} </td>
        
                                    <td> {{ item.strMobileGroup_strComment }} </td>
        
                                    <td> {{ item.strSCityName }} </td>
        
                                    <td> {{ item.strDCityName }} </td>
                                    
                                    <td *ngIf="!bEmdadran"> {{ item.iEstimateRent.toLocaleString() | faNum }} </td>

                                </ng-container>

                                <!--در انتظار شروع, در حال اجرا -->

                                <ng-container *ngIf="tiTripStatus == 4 || tiTripStatus == 5">
                                    
                                    <td>{{ i + 1 | faNum }}</td>

                                    <td class="">

                                        <i class="fa fa-info-circle fa-lg pointer" (click)="newRequest(item,i,'showMode')"></i>

                                        <i class="fa fa-map-pin fa-lg pointer mx-2" [title]="bEmdadran ? 'موقعیت امدادگر' : 'موقعیت' " (click)="show_Car_OnMap(item)"> </i>

                                        <!-- در حال اجرا -->

                                        <ng-container *ngIf="tiTripStatus == 5">

                                            <i class="fa fa-window-close mx-2 fa-lg pointer" title="خاتمه" (click)="finishRequest(item,i)"></i>

                                            <i class="fa fa-car fa-lg text-muted pointer" title="اختصاص خودرو بر اساس وضعیت" (click)="open_AssignModal_2(bEmdadran ? item.iEmdadRo : item.iTaxiLon_Trip)"></i>

                                            <i class="fa fa-car fa-lg me-2 text-success pointer" [title]="bEmdadran ? 'امدادگران رزرو' : 'رانندگان رزرو' " (click)="open_AssignModal_2(bEmdadran ? item.iEmdadRo : item.iTaxiLon_Trip,true)"></i>

                                        </ng-container>

                                        <!-- در انتظار شروع -->

                                        <ng-container *ngIf="tiTripStatus == 4">

                                            <i class="fa fa-pencil-square fa-lg pointer" title="ویرایش" (click)="newRequest(item,i)"></i>
                                            
                                            <i class="fa fa-window-close mx-2 fa-lg pointer" [title]="bEmdadran ? 'لغو درخواست' : 'لغو سفر' " (click)="cancelRequest(item,i)"></i>

                                            <i class="fa fa-id-card-o fa-lg pointer" title="وضعیت دریافت پیشنهاد" (click)="suggestion_Status(item)"></i>

                                            <i class="fa fa-car fa-lg mx-2 text-muted pointer" title="اختصاص خودرو بر اساس وضعیت" (click)="open_AssignModal_2(bEmdadran ? item.iEmdadRo : item.iTaxiLon_Trip)"></i>

                                            <i *ngIf="false" class="fa fa-car fa-lg text-primary pointer" title="اختصاص براساس برنامه" (click)="open_AssignModal(bEmdadran ? item.iEmdadRo : item.iTaxiLon_Trip)"></i>
    
                                            <i class="fa fa-car fa-lg mx-2 text-success pointer" [title]="bEmdadran ? 'امدادگران رزرو' : 'رانندگان رزرو' " (click)="open_AssignModal_2(bEmdadran ? item.iEmdadRo : item.iTaxiLon_Trip,true)"></i>

                                        </ng-container>

                                    </td>      

                                    <td> {{ (bEmdadran ? item.iEmdadRo : item.iTaxiLon_Trip) | faNum }} </td>
        
                                    <td *ngIf="!bEmdadran"> {{ item.strTaxiLon_TripStatus_strComment | faNum }} </td>
        
                                    <td> {{ item.strDriver_FullName }} </td>
                                    
                                    <td> {{ item.strDriver_Mobile | faNum }} </td>
                                    
                                    <td> {{ item.strDate | faNum }} </td>
                                    
                                    <td> {{ item.strTime | faNum }} </td>
        
                                    <td> {{ item.strSCityName }} </td>
        
                                    <td> {{ item.strDCityName }} </td>

                                    <td *ngIf="bEmdadran"> {{ item.strMobileGroup_strComment }} </td>

                                    <td *ngIf="!bEmdadran"> {{ item.iEstimateRent.toLocaleString() | faNum }} </td>

                                    <td *ngIf="tiTripStatus == 5"> {{ item.strTaxiLon_TripStatus_strComment }} </td>

                                </ng-container>
                                
                                <!-- درخواست های جدید -->

                                <ng-container *ngIf="tiTripStatus == 10">

                                    <td>{{ i + 1 | faNum }}</td>

                                    <td class="">

                                        <i class="fa fa-info-circle fa-lg pointer" (click)="newRequest(item,i,'showMode')"></i>

                                    </td>  
                                            
                                    <td> {{ bEmdadran ? item.iEmdadRo : item.iTaxiLon_Trip | faNum }} </td>
        
                                    <td> {{ item.strTaxiLon_TripStatus_strComment | faNum }} </td>
        
                                    <td> {{ item.strFullName }} </td>

                                    <td> {{ item.iEstimateRent.toLocaleString() | faNum }} </td>

                                </ng-container>

                            </ng-container>
                                    
                        </tr>
    
                    </tbody>
    
                </table>
    
            </div>
    
        </div>

    </section>

    <!-- مدال اختصاص خودرو براساس برنامه -->

    <div class="modal fade" id="assignModal" tabindex="-1">

        <div class="modal-dialog modal-xl">
    
            <div class="modal-content dirI">
    
                <div class="modal-header dirI">
    
                    <h5 class="modal-title" id="exampleModalLabel"> اختصاص راننده براساس برنامه </h5>
    
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    
                </div>
    
                <div class="modal-body">

                    <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." (input)="filter_Result_2($event.target.value)">

                    <div class="col-12 section border border-2 mt-2" style="max-height:calc(100vh - 270px);overflow: auto;">
    
                        <table class="col-12 table table-striped rounded-3" id="Export_Excel">
            
                            <thead class="">
        
                                <tr class="">
        
                                    <th class="text-center col-1"> # </th>

                                    <th class="text-center col-1 pointer" (click)="selectAll_Driver()"> انتخاب </th>

                                    <th class="text-center col-1"> تاریخ </th>

                                    <th class="text-center"> ساعت </th>

                                    <th class="text-center"> شهر مبداء </th>

                                    <th class="text-center"> گروه خودرویی </th>
            
                                    <th class="text-center"> نام خودرو </th>

                                    <th class="text-center"> نوع خودرو </th>
                                    
                                    <th class="text-center"> مدل خودرو </th>
            
                                    <th class="text-center"> نام راننده </th>
                                    
                                    <th class="text-center"> موبایل </th>

                                    <th class="text-center"> فاصله خودرو تا مبدا </th>
                        
                                    <th class="text-center" style="background-color: #6ee7b7;"> سفر&zwnj;ها </th>

                                    <th class="text-center" style="background-color: #fda4af;"> لغو&zwnj;ها </th>
    
                                </tr>
            
                            </thead>
            
                            <tbody class="">
            
                                <tr class="col-12 text-center" *ngFor="let item of lst_TaxiLon_Driver;let i = index">
        
                                    <td>{{ i + 1 | faNum }}</td>

                                    <td class="pointer"> 
                                        
                                        <input type="checkbox"

                                            [checked]="isSelected(item.strUnitID)"
                                        
                                            (change)="select_Driver($event.target.checked,item)"

                                            title="اختصاص خودرو بر اساس وضعیت">
                                    
                                    </td>
        
                                    <td> {{ item.strDate | faNum }} </td>

                                    <td> {{ item.strSTime | faNum }} </td>

                                    <td> {{ item.strCityName | faNum }} </td>

                                    <td> {{ item.strMobileGroup_strComment | faNum }} </td>
        
                                    <td> {{ item.strGPSType_strComment | faNum }} </td>

                                    <td> {{ item.strMobileType_strComment | faNum }} </td>

                                    <td> {{ item.iYearConstruction | faNum }} </td>
        
                                    <td> {{ item.strFullName | faNum }} </td>
                                    
                                    <td> {{ item.strMobile | faNum }} </td>

                                    <td> {{ item.DistanceKM.toLocaleString() | faNum }} </td>
                                                                                
                                    <td style="background-color: #6ee7b7;"> {{ item.iTrip | faNum }} </td>
        
                                    <td style="background-color: #fda4af;"> {{ item.iCancel | faNum }} </td>
                                            
                                </tr>
            
                            </tbody>
            
                        </table>
            
                    </div>
    
                </div>
    
                <div class="modal-footer d-flex justify-content-start">
    
                    <button class="btn btn-success" (click)="assignCar()">
    
                        &nbsp; تایید &nbsp;
    
                    </button>

                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
    
                        &nbsp; بستن &nbsp;
    
                    </button>
    
                </div>
    
            </div>
    
        </div>
    
    </div>

    <!-- مدال اختصاص خودرو بر اساس وضعیت  -->

    <div class="modal fade" id="assignModal_2" tabindex="-1">

        <div class="modal-dialog modal-xl">
    
            <div class="modal-content dirI">
    
                <div class="modal-header dirI">
    
                    <h5 class="modal-title" id="exampleModalLabel"> اختصاص خودرو </h5>
    
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    
                </div>
    
                <div [formGroup]="mdl_AssignCar" class="modal-body">
                    
                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bAll" formControlName="bAll" (change)="toggleCarData(mdl_AssignCar.get('bAll')?.value)">

                        <label class="form-check-label pointer text-muted me-2" for="bAll"> خودروهای فعال </label>

                    </div>

                    <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." (input)="filter_Result_2($event.target.value)">

                    <div class="col-12 section border border-2 mt-2" style="max-height:calc(100vh - 270px);overflow: auto;">
    
                        <table class="col-12 table table-striped rounded-3" id="Export_Excel">
            
                            <thead class="">
        
                                <tr class="">
        
                                    <th class="text-center col-1"> # </th>

                                    <th class="text-center col-1 pointer"> عملیات </th>

                                    <th class="text-center col-1 pointer" (click)="selectAll_Driver()"> انتخاب </th>

                                    <th class="text-center"> گروه خودرویی </th>

                                    <th class="text-center"> شهر </th>

                                    <th class="text-center pointer" (click)="sortColumn_Date()"> تاریخ لاگ  <i class="fa fa-sort"></i></th>

                                    <th class="text-center pointer" (click)="sortColumn_Time()"> ساعت لاگ <i class="fa fa-sort"></i></th>
            
                                    <th class="text-center"> نام خودرو </th>

                                    <th class="text-center"> نوع خودرو </th>
                                    
                                    <th class="text-center"> مدل خودرو </th>
            
                                    <th class="text-center"> نام راننده </th>
                                    
                                    <th class="text-center"> موبایل </th>

                                    <th class="text-center"> فاصله خودرو تا مبدا </th>
                        
                                    <th class="text-center pointer" style="background-color: #6ee7b7;" (click)="sortColumn_Trip()"> سفر&zwnj;ها <i class="fa fa-sort"></i> </th>

                                    <th class="text-center pointer" style="background-color: #fda4af;" (click)="sortColumn_Cancel()"> لغو&zwnj;ها <i class="fa fa-sort"></i> </th>
    
                                </tr>
            
                            </thead>
            
                            <tbody class="">
            
                                <tr class="col-12 text-center" *ngFor="let item of lst_TaxiLon_Driver;let i = index">
        
                                    <th> {{ i + 1 | faNum }} </th>

                                    <td class="text-center">

                                        <i class="fa fa-info-circle fa-lg pointer" title="مشخصات" (click)="show_CarInfo(item)"></i>

                                        <ng-container *ngIf="item.fLat != 0 && item.fLon != 0">

                                            <i class="fa fa-map-pin mx-3 fa-lg text-success pointer" title="موقعیت" (click)="showMap(item)"></i>

                                        </ng-container>

                                    </td>

                                    <td class="pointer"> 
                                        
                                        <input type="checkbox"

                                            [checked]="isSelected(item.strUnitID)"
                                        
                                            (change)="select_Driver($event.target.checked,item)"

                                            title="اختصاص خودرو بر اساس وضعیت">
                                    
                                    </td>
        
                                    <td> {{ item.strMobileType_strComment | faNum }} </td>

                                    <td></td>

                                    <td> {{ item.strDate | faNum }} </td>

                                    <td> {{ item.strTime | faNum }} </td>
        
                                    <td> {{ item.strGPSType_strComment | faNum }} </td>

                                    <td> {{ item.strMobileGroup_strComment | faNum }} </td>

                                    <td> {{ item.iYearConstruction | faNum }} </td>
        
                                    <td> {{ item.strFullName | faNum }} </td>
                                    
                                    <td> {{ item.strMobile | faNum }} </td>

                                    <td> {{ item.DistanceKM.toLocaleString() | faNum }} </td>
                                                                                
                                    <td style="background-color: #6ee7b7;"> {{ item.iTrip | faNum }} </td>
        
                                    <td style="background-color: #fda4af;"> {{ item.iCancel | faNum }} </td>
                                            
                                </tr>
            
                            </tbody>
            
                        </table>
            
                    </div>

                    <custom-map *ngIf="showCustom_Map_2"
                    
                        [strValue]="mdl_Map.get('strAddress')?.value"
            
                        [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]"

                        [isOpenModal]="true"

                        [isView]="true"

                        (mdl_Submit)="submitMap($event)">

                    </custom-map>
    
                </div>
    
                <div class="modal-footer d-flex justify-content-start">
    
                    <button class="btn btn-success" (click)="assignCar_2()">
    
                        &nbsp; تایید &nbsp;
    
                    </button>

                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
    
                        &nbsp; بستن &nbsp;
    
                    </button>
    
                </div>
    
            </div>
    
        </div>
    
    </div>

    <!-- مدال وضعیت دریافت پیشنهادات -->

    <div class="modal fade" id="assignModal_3" tabindex="-1">

        <div class="modal-dialog modal-xl">
    
            <div class="modal-content dirI">
    
                <div class="modal-header dirI">
    
                    <h5 class="modal-title" id="exampleModalLabel"> وضعیت دریافت پیشنهاد </h5>
    
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    
                </div>
    
                <div class="modal-body">

                    <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." (input)="filter_Result_3($event.target.value)">

                    <div class="col-12 section border border-2 mt-2" style="max-height:calc(100vh - 270px);overflow: auto;">
    
                        <table class="col-12 table table-striped rounded-3" id="Export_Excel">
            
                            <thead class="">
        
                                <tr class="">
        
                                    <th class="text-center col-1"> # </th>

                                    <th class="text-center col-1 pointer" (click)="selectAll_Driver()"> انتخاب </th>

                                    <th class="text-center"> گروه خودرویی </th>

                                    <th class="text-center"> نام راننده </th>
                                    
                                    <th class="text-center"> موبایل </th>

                                    <th class="text-center"> وضعیت </th>

                                    <th class="text-center"> فاصله خودرو تا مبدا </th>

                                    <th class="text-center pointer" (click)="sortColumn()"> زمان دریافت <i class="fa fa-sort"></i> </th>
                        
                                </tr>
            
                            </thead>
            
                            <tbody class="">
            
                                <tr class="col-12 text-center" *ngFor="let item of lst_Suggestion;let i = index">
        
                                    <th> {{ i + 1 | faNum }} </th>

                                    <td class="pointer"> 
                                        
                                        <input type="checkbox" [checked]="isSelected(item.strUnitID)" (change)="select_Driver($event.target.checked,item)">
                                    
                                    </td>
        
                                    <td> {{ item.strMobileGroup_strComment | faNum }} </td>

                                    <td> {{ item.strFullName | faNum }} </td>

                                    <td> {{ item.strMobile | faNum }} </td>

                                    <td> {{ item.srtrResponseType | faNum }} </td>

                                    <td> {{ item.DistanceKM.toLocaleString() | faNum }} </td>

                                    <td> {{ item.strTime | faNum }} </td>

                                </tr>
            
                            </tbody>
            
                        </table>
            
                    </div>

    
                </div>
    
                <div class="modal-footer d-flex justify-content-start">
    
                    <button class="btn btn-success" (click)="assignCar_2()">
    
                        &nbsp; تایید &nbsp;
    
                    </button>

                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
    
                        &nbsp; بستن &nbsp;
    
                    </button>
    
                </div>
    
            </div>
    
        </div>
    
    </div>

    <!-- مدال افزودن امداد -->

    <div class="modal fade" id="newEmdad_Modal">    

        <div class="modal-dialog modal-lg modal-fullscreen-sm-down">
    
            <div class="modal-content dirI">
    
                <div class="modal-header">
    
                    <h5 class="modal-title" id="exampleModalLabel">

                        {{ 
                            
                            bEditMode == 'showMode' ? 'مشاهده درخواست' :
                            
                            bEditMode == true ? 'ویرایش درخواست امداد' :
                            
                            'ثبت درخواست امداد'
                            
                        }}
                        
                    </h5>
    
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    
                </div>
    
                <div class="modal-body" style="max-height: 76vh;overflow: auto;" [ngClass]="bEditMode == 'showMode' ? 'disabled-child' : '' ">
    
                    <div [formGroup]="mdl_TripSAD" class="container-fluid row gx-2 gy-md-0 gy-2 px-2">
    
                        <!-- موبایل متقاضی  -->
    
                        <div class="position-relative col-12 col-md-4 p-2">
                    
                            <label> موبایل متقاضی  * </label>
                
                            <input class="form-control p-2 text-center"
                            
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
    
                                maxlength="11"
    
                                formControlName="strMobile">
    
                            <ng-container *ngIf="bEditMode != 'showMode'">
    
                                <button class="btn btn-primary rounded" (click)="search_ByMobile_Emdadran()">
    
                                    <i class="fa fa-search" aria-hidden="true"></i>
                                    
                                </button>
    
                            </ng-container>
                
                        </div>
    
                        <!-- نام متقاضی  -->
    
                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="text-muted" > نام متقاضی  </label>
                
                            <input class="form-control p-2 text-center" formControlName="strName">
                
                        </div>
    
                        <!-- نام خانوادگی متقاضی  -->
    
                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="text-muted"> نام خانوادگی متقاضی  * </label>
                
                            <input class="form-control p-2 text-center" formControlName="strFamily">
                
                        </div>
                            
                        <!-- نوع درخواست امداد  -->
    
                        <div *ngIf="showFilter" class="col-12 col-md-4 position-relative p-2">
    
                            <div class="w-100" *ngIf="list_ReliefType.length">
    
                                <label class="text-muted"> نوع درخواست * </label>
    
                                <custom-filter 
    
                                    [strValue]="returnStrValue('tiReliefRequestType',mdl_TripSAD.get('tiReliefRequestType')?.value,list_ReliefType,'strComment')"
    
                                    [strComment]="'strComment'"
    
                                    [stylesArray]="['padding-top: 10px','text-align: center']"
    
                                    [str_Placeholder]="' جستجو کنید ...'" 
                                    
                                    [lst_Main]="list_ReliefType"
    
                                    [lst_SearchKey]="['strComment']" 
                                    
                                    [isDisabled]="false"
    
                                    (hideOptions)="updateValue($event.tiReliefRequestType)">
    
                                </custom-filter>
    
                            </div>
    
                        </div>
    
                        <!-- نوع خودرو -->
    
                        <div *ngIf="showFilter" class="col-12 col-md-4 position-relative p-2">
    
                            <div class="w-100" *ngIf="list_MobileType?.length">
    
                                <label class="text-muted"> نوع خودرو * </label>
    
                                <custom-filter 
    
                                    [strValue]="returnStrValue('tiMobileType',mdl_TripSAD.get('tiMobileType')?.value,list_MobileType,'strComment')"
    
                                    [strComment]="'strComment'"
    
                                    [stylesArray]="['padding-top: 10px','text-align: center']"
    
                                    [str_Placeholder]="' جستجو کنید ...'" [lst_Main]="list_MobileType"
    
                                    [lst_SearchKey]="['strComment']" [isDisabled]="false"
    
                                    (hideOptions)="mdl_TripSAD.get('tiMobileType')?.setValue($event.tiMobileType)">
    
                                </custom-filter>
    
                            </div>
    
                        </div>
    
                        <!-- پلاک خودرو -->
    
                        <div class="col-12 col-md-4 position-relative p-2">
    
                            <div class="w-100">
    
                                <label class="text-muted"> پلاک خودرو *</label>
    
                                <div class="plate-container d-flex">
    
                                    <input class="form-control text-center w-25 p-2" 
                                    
                                        oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                                    
                                        maxlength="2" placeholder="- -" 
                                        
                                        formControlName="strVehicleNo_4">
    
                                    <input class="form-control text-center w-25 p-2" 
                                    
                                        oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                                    
                                        maxlength="3" placeholder="- - -" 
                                        
                                        formControlName="strVehicleNo_3">
    
                                    <input class="form-control text-center w-25 p-2" 
    
                                        oninput="this.value=this.value.replace(/[^ء-ی]/g, '')"
                                    
                                        maxlength="1" placeholder="-" 
                                        
                                        formControlName="strVehicleNo_2">
    
                                    <input class="form-control text-center w-25 p-2" 
                                    
                                        oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                                    
                                        maxlength="2" placeholder="- -" 
                                        
                                        formControlName="strVehicleNo_1">
    
                                </div>
    
                            </div>
    
                        </div>
    
                        <!-- علت درخواست امداد -->
    
                        <div *ngIf="showFilter && !isInput_Disabled" class="col-12 col-md-4 position-relative p-2">
    
                            <div class="w-100" *ngIf="list_Reason.length">
    
                                <label class="text-muted"> علت درخواست * </label>
    
                                <custom-filter 
    
                                    [strValue]="returnStrValue('tiReason4Request',mdl_TripSAD.get('tiReason4Request')?.value,list_Reason,'strComment')"
    
                                    [strComment]="'strComment'"
    
                                    [stylesArray]="['padding-top: 10px','text-align: center']"
    
                                    [str_Placeholder]="' جستجو کنید ...'" 
                                    
                                    [lst_Main]="list_Reason"
    
                                    [lst_SearchKey]="['strComment']" 
                                    
                                    [isDisabled]="false"
    
                                    (hideOptions)="mdl_TripSAD.get('tiReason4Request')?.setValue($event.tiReason4Request)">
    
                                </custom-filter>
    
                            </div>
    
                        </div>
    
                        <!-- دلیل توقف -->
    
                        <div [ngClass]="isInput_Disabled ? 'col-md-12' : 'col-md-4'" class="position-relative col-12 p-2">
    
                            <div class="w-100">
    
                                <label class="text-muted"> دلیل توقف </label>
    
                                <input class="form-control w-100 p-2" formControlName="strReasonStopping" placeholder="دلیل توقف خود را مشخص کنید...">
    
                            </div>
    
                        </div>
    
                        <!-- نوع امدادگر  -->
    
                        <div *ngIf="showFilter && !isInput_Disabled" class="col-12 col-md-4 position-relative p-2">
    
                            <div class="w-100" *ngIf="list_MobileGroup.length">
    
                                <label class="text-muted"> نوع امدادگر * </label>
    
                                <custom-filter 
    
                                    [strValue]="returnStrValue('tiMobileGroup',mdl_TripSAD.get('tiMobileGroup')?.value,list_MobileGroup,'strComment')"
    
                                    [strComment]="'strComment'"
    
                                    [stylesArray]="['padding-top: 10px','text-align: center']"
    
                                    [str_Placeholder]="' جستجو کنید ...'" 
                                    
                                    [lst_Main]="list_MobileGroup"
    
                                    [lst_SearchKey]="['strComment']" 
                                    
                                    [isDisabled]="false"
    
                                    (hideOptions)="mdl_TripSAD.get('tiMobileGroup')?.setValue($event.tiMobileGroup)">
    
                                </custom-filter>
    
                            </div>
    
                        </div>
    
                        <!-- شهر مبداء -->

                        <div class="position-relative col-12 col-md-4 p-2">
        
                            <label class="text-muted"> شهر مبداء </label>
        
                            <custom-filter *ngIf="showFilter"

                                [strValue]="returnStrValue(bEditMode || bEditMode == 'searchMode' || isCity ? 'strCity' : 'strSCity', mdl_TripSAD.get('strSCity')?.value,lst_City,'strCityName')"
                        
                                [strComment]="'strCityName'"
                        
                                [stylesArray]="['padding-top: 10px','text-align: start']"
                        
                                [str_Placeholder]="' جستجو کنید...'"
                        
                                [lst_Main]="lst_City" 
                        
                                [lst_SearchKey]="['strCityName']"
                        
                                [isDisabled]="mdl_TripSAD.disabled || isCity && Selected_City != '' ? true : false"
                                
                                (hideOptions)="setValue_Filter($event,'strSCity')">
                    
                            </custom-filter>
        
                        </div>

                        <!-- آدرس مبداء -->

                        <div class="position-relative col-12 col-md-8 p-2">

                            <label class="mb-2 text-muted"> آدرس مبداء </label>

                            <input class="form-control p-2 text-start" 

                                [placeholder]="isCity ? 'تهران، خیابان ولیعصر' : 'آدرس مبداء خود را جستجو کنید ...' "
                            
                                formControlName="strSAddress">    

                            <ng-container *ngIf="bEditMode != 'showMode'">

                                <button class="btn btn-warning rounded" (click)="show_Map('strSAddress')">

                                    <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                                
                                </button>

                            </ng-container>

                    
                        </div>
                        
                        <!-- شهر مقصد -->

                        <div *ngIf="!isInput_Disabled" class="position-relative col-12 col-md-4 p-2">
        
                            <label class="text-muted"> شهر مقصد </label>
        
                            <custom-filter *ngIf="showFilter"

                                [strValue]="returnStrValue(bEditMode || isCity ? 'strCity' : 'strDCity',mdl_TripSAD.get('strDCity')?.value,lst_City,'strCityName')"
                        
                                [strComment]="'strCityName'"
                        
                                [stylesArray]="['padding-top: 10px','text-align: start']"
                        
                                [str_Placeholder]="' جستجو کنید...'"
                        
                                [lst_Main]="lst_City" 
                        
                                [lst_SearchKey]="['strCityName']"
                        
                                [isDisabled]="mdl_TripSAD.disabled || isCity && Selected_City != '' ? true : false"
                                
                                (hideOptions)="setValue_Filter($event,'strDCity')">
                    
                            </custom-filter>
        
                        </div>

                        <!-- آدرس مقصد -->

                        <div *ngIf="!isInput_Disabled" class="position-relative col-12 col-md-8 p-2">

                            <label class="mb-2 text-muted"> آدرس مقصد </label>

                            <input class="form-control p-2 text-start" 

                                [placeholder]="isCity ? 'تهران، خیابان ولیعصر' : 'آدرس مقصد خود را جستجو کنید ...' "
                            
                                formControlName="strDAddress">    

                            <ng-container *ngIf="bEditMode != 'showMode'">

                                <button class="btn btn-warning rounded" (click)="show_Map('strDAddress')">

                                    <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                                
                                </button>

                            </ng-container>
                                               
                        </div>

                        <!-- مدال نقشه -->

                        <custom-map *ngIf="showCustom_Map_3"
                    
                            [strValue]="mdl_Map.get('strAddress')?.value"
                
                            [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]"

                            [isOpenModal]="true"

                            (mdl_Submit)="submitMap($event)">
            
                        </custom-map>
    
                        <!-- تاریخ -->
    
                        <div class="col-12 col-md-4 position-relative p-2">
    
                            <label class="text-muted"> تاریخ * </label>
    
                            <ng-persian-datepicker [uiTheme]="'gray'" 
                            
                                [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">
    
                                <input style="background-color: #ffff;" class="form-control p-2 text-end" formControlName="strDate" readonly />
    
                            </ng-persian-datepicker>
    
                        </div>
    
                        <!-- ساعت -->
    
                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="mb-2 text-muted" style="z-index: 10;"> ساعت * </label>
                    
                            <div class="input-group clockpicker">
                    
                                <input type="text" class="form-control p-2 text-center" id="strTime" formControlName="strTime">
                    
                                <span class="input-group-addon">
                    
                                    <span class="glyphicon glyphicon-time"></span>
                    
                                </span>
                    
                            </div>
                    
                        </div>
                        
                        <!-- هزینه سرویس  -->
    
                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="text-muted" > هزینه سرویس  </label>
                
                            <input class="form-control p-2 text-center" formControlName="iBaseRent" style="background-color: #e9ecef!important;" disabled>

                            <ng-container *ngIf="bEditMode != 'showMode' && mdl_TripSAD.get('fDLon')?.value != '0'">

                                <button class="btn btn-primary rounded" (click)="calc_Renting_2()">

                                    <i class="fa fa-calculator fa-lg" aria-hidden="true"></i>
                                
                                </button>

                            </ng-container>
                
                        </div>
                        
                        <!-- هزینه توافق شده(ریال)  -->
    
                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="text-muted" > هزینه توافق شده(ریال)  </label>
                
                            <input class="form-control p-2 text-center" formControlName="iFixCost">
                
                        </div>

                        <!-- کمسیون(درصد) -->
    
                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="text-muted" > کمسیون(درصد) </label>
                
                            <input class="form-control p-2 text-center" formControlName="tiCommissionPercentage">
                
                        </div>
    
                        <!-- طرح ترافیک -->
    
                        <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2 mt-2">
    
                            <input class="form-check-input m-0" type="checkbox" id="bTraffic" formControlName="bTraffic">
                        
                            <label class="form-check-label pointer text-muted me-2" for="bTraffic"> طرح ترافیک </label>
                        
                        </div>
    
                        <!-- طرح آلودگی -->
    
                        <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2 mt-2">
    
                            <input class="form-check-input m-0" type="checkbox" id="bEvenOdd" formControlName="bEvenOdd">
                        
                            <label class="form-check-label pointer text-muted me-2" for="bEvenOdd"> طرح آلودگی </label>
                        
                        </div>
    
                        <!-- شرایط آب وهوایی ویژه -->
    
                        <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2 mt-2">
    
                            <input class="form-check-input m-0" type="checkbox" id="bBadWeather" formControlName="bBadWeather">
                        
                            <label class="form-check-label pointer text-muted me-2" for="bBadWeather"> شرایط آب وهوایی ویژه </label>
                        
                        </div>
    
                        <!-- منطقه کوهستانی -->
    
                        <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2 mt-2">
    
                            <input class="form-check-input m-0" type="checkbox" id="bMountainous" formControlName="bMountainous">
                        
                            <label class="form-check-label pointer text-muted me-2" for="bMountainous"> منطقه کوهستانی </label>
                        
                        </div>
    
                        <!-- توضیحات -->
    
                        <div class="col-12 position-relative mt-2">
    
                            <div class="w-100">
    
                                <textarea class="form-control w-100" 

                                    style="resize: none;"
                                
                                    formControlName="strComment" 
                                
                                    [placeholder]="isInput_Disabled ? '* توضیحات خود را وارد کنید ...' : 'توضیحات خود را وارد کنید ..' ">
                                
                                </textarea>
    
                            </div>
    
                        </div>
    
                    </div>
    
                </div>
    
                <div *ngIf="bEditMode != 'showMode'"  class="modal-footer d-flex justify-content-start">
    
                    <!-- ثبت -->
    
                    <button [ngClass]="bEditMode == true ? 'btn-primary' : 'btn-success'" class="btn" (click)="submit_Emdadran()"> 
                        
                        {{ bEditMode == true ? 'ویرایش درخواست' : 'ثبت درخواست' }}
                    
                    </button>
    
                    <!-- بستن -->
    
                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
    
                        &nbsp; بستن &nbsp;
    
                    </button>
    
                </div>
    
            </div>
    
        </div>
    
    </div>

</main>

<!-- مدال افزودن, ویرایش سرویس -->

<div class="modal fade" id="newReq_Modal">    

        <div class="modal-dialog modal-lg modal-fullscreen-sm-down">
    
            <div class="modal-content dirI">
    
                <div class="modal-header dirI">
    
                    <h5 class="modal-title" id="exampleModalLabel"> 

                        {{ bEditMode == true ? 'ویرایش سرویس' : bEditMode == 'showMode' ? 'مشاهده اطلاعات' : 'افزودن سرویس'  }}
                        
                    </h5>
    
                    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal()"></button>
    
                </div>
    
                <div class="modal-body" style="max-height: 76vh;overflow: auto;" [ngClass]="bEditMode == 'showMode' ? 'disabled-child' : '' ">

                    <div [formGroup]="mdl_Request" class="container-fluid row gx-2 gy-md-0 gy-2 p-2">

                        <!-- موبایل مسافر -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted"> موبایل مسافر </label>
                
                            <input class="form-control p-2 text-center"
                            
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"

                                maxlength="11"

                                formControlName="strMobile">

                            <ng-container *ngIf="bEditMode != 'showMode'">

                                <button class="btn btn-primary rounded" (click)="search_ByMobile()">
    
                                    <i class="fa fa-search" aria-hidden="true"></i>
                                    
                                </button>
    
                            </ng-container>
                
                        </div>

                        <!-- نام مسافر -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted"> نام مسافر </label>
                
                            <input class="form-control p-2 text-center" formControlName="strName">
                
                        </div>

                        <!-- نام خانوادگی مسافر -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted"> نام خانوادگی مسافر </label>
                
                            <input class="form-control p-2 text-center" formControlName="strFamily">
                
                        </div>

                        <!-- جنسیت -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted"> جنسیت </label>
                
                            <select class="form-select p-2" formControlName="tiSex">
                
                                <option class="text-center" [value]="1"> مرد </option>

                                <option class="text-center" [value]="1"> زن </option>
                
                            </select>
                
                        </div>
                        
                        <!-- کد ملی -->

                        <ng-container *ngIf="!isCity">

                            <div class="position-relative col-12 col-md-4 p-2">
                
                                <label class="mb-2 text-muted"> کد ملی </label>
                    
                                <input class="form-control p-2 text-center"
                                
                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
    
                                    maxlength="10"
    
                                    formControlName="strID">
                    
                            </div>

                        </ng-container>

                        <!-- تاریخ سفر -->
                
                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted"> تاریخ سفر </label>
                
                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
                
                                <input formControlName="strDate" class="form-control p-2 text-end" />
                
                            </ng-persian-datepicker>
                
                        </div>

                        <!-- ساعت سفر -->
                        
                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="mb-2 text-muted" style="z-index: 10;"> ساعت سفر </label>

                            <div class="input-group clockpicker">

                                <input type="text" class="form-control p-2 text-center" id="strTime_" formControlName="strTime">

                                <span class="input-group-addon">

                                    <span class="glyphicon glyphicon-time"></span>

                                </span>

                            </div>

                        </div>

                        <!-- تعداد مسافر -->

                        <ng-container *ngIf="!isCity">

                            <div class="position-relative col-12 col-md-4 p-2">
                
                                <label class="mb-2 text-muted"> تعداد مسافر </label>
                    
                                <input class="form-control p-2 text-center"
                                
                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
    
                                    maxlength="2" formControlName="tiPassenger">
    
                            </div>

                            <!-- جدا کننده -->

                            <div class="position-relative col-0 col-md-4 p-2">

                            </div>

                        </ng-container>

                        <!-- شهر مبداء -->

                        <div class="position-relative col-12 col-md-4 p-2">
        
                            <label class="text-muted"> شهر مبداء </label>
        
                            <custom-filter *ngIf="showFilter"

                                [strValue]="returnStrValue(bEditMode || bEditMode == 'searchMode' || isCity ? 'strCity' : 'strSCity', mdl_Request.get('strSCity')?.value,lst_City,'strCityName')"
                        
                                [strComment]="'strCityName'"
                        
                                [stylesArray]="['padding-top: 10px','text-align: start']"
                        
                                [str_Placeholder]="' جستجو کنید...'"
                        
                                [lst_Main]="lst_City" 
                        
                                [lst_SearchKey]="['strCityName']"
                        
                                [isDisabled]="mdl_Request.disabled || isCity && Selected_City != '' ? true : false"
                                
                                (hideOptions)="setValue_Filter($event,'strSCity')">
                    
                            </custom-filter>
        
                        </div>

                        <!-- آدرس مبداء -->

                        <div class="position-relative col-12 col-md-8 p-2">

                            <label class="mb-2 text-muted"> آدرس مبداء </label>

                            <input class="form-control p-2 text-start" 

                                [placeholder]="isCity ? 'تهران، خیابان ولیعصر' : 'آدرس مبداء خود را جستجو کنید ...' "
                            
                                formControlName="strSAddress">    

                            <ng-container *ngIf="bEditMode != 'showMode'">

                                <button class="btn btn-warning rounded" (click)="show_Map('strSAddress')">

                                    <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                                
                                </button>

                            </ng-container>

                    
                        </div>
                        
                        <!-- شهر مقصد -->

                        <div class="position-relative col-12 col-md-4 p-2">
        
                            <label class="text-muted"> شهر مقصد </label>
        
                            <custom-filter *ngIf="showFilter"

                                [strValue]="returnStrValue(bEditMode || isCity ? 'strCity' : 'strDCity',mdl_Request.get('strDCity')?.value,lst_City,'strCityName')"
                        
                                [strComment]="'strCityName'"
                        
                                [stylesArray]="['padding-top: 10px','text-align: start']"
                        
                                [str_Placeholder]="' جستجو کنید...'"
                        
                                [lst_Main]="lst_City" 
                        
                                [lst_SearchKey]="['strCityName']"
                        
                                [isDisabled]="mdl_Request.disabled || isCity && Selected_City != '' ? true : false"
                                
                                (hideOptions)="setValue_Filter($event,'strDCity')">
                    
                            </custom-filter>
        
                        </div>

                        <!-- آدرس مقصد -->

                        <div class="position-relative col-12 col-md-8 p-2">

                            <label class="mb-2 text-muted"> آدرس مقصد </label>

                            <input class="form-control p-2 text-start" 

                                [placeholder]="isCity ? 'تهران، خیابان ولیعصر' : 'آدرس مقصد خود را جستجو کنید ...' "
                            
                                formControlName="strDAddress">    

                            <ng-container *ngIf="bEditMode != 'showMode'">

                                <button class="btn btn-warning rounded" (click)="show_Map('strDAddress')">

                                    <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                                
                                </button>

                            </ng-container>
                                               
                        </div>

                        <!-- مدال نقشه -->

                        <custom-map *ngIf="showCustom_Map"
                    
                            [strValue]="mdl_Map.get('strAddress')?.value"
                
                            [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]"

                            [isOpenModal]="true"

                            (mdl_Submit)="submitMap($event)">
            
                        </custom-map>

                        <!-- تاکسی بین شهری -->

                        <ng-container *ngIf="!isCity">

                            <!-- سرویس برای دیگری -->

                            <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bForAnother')?.value || bEditMode != 'showMode'">

                                <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">
    
                                    <input class="form-check-input m-0" type="checkbox" id="bForAnother" formControlName="bForAnother">
                                
                                    <label class="form-check-label pointer text-muted me-2" for="bForAnother"> سرویس برای دیگری </label>
                                
                                </div>
    
                            </ng-container>
                                                    
                            <!-- نام و نام خانوادگی متقاضی -->
    
                            <div *ngIf="mdl_Request.get('bForAnother')?.value" class="position-relative col-12 col-md-12 p-2">
    
                                <ng-container *ngIf="mdl_Request.get('bForAnother')?.value">
                   
                                    <label class="mb-2 text-muted"> نام و نام خانوادگی متقاضی </label>
                        
                                    <input class="form-control p-2 text-start" formControlName="strPassengersName">
    
                                </ng-container>
                    
                            </div>
    
                            <!-- سرویس شامل بار می باشد -->
    
                            <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bCargo')?.value || bEditMode != 'showMode'">
    
                                <div class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">
    
                                    <input class="form-check-input m-0" type="checkbox" id="bCargo" formControlName="bCargo">
                                
                                    <label class="form-check-label pointer text-muted me-2" for="bCargo"> سرویس شامل بار می باشد </label>
                                
                                </div>
    
                            </ng-container>
                            
                            <!-- توضیحات بار -->
    
                            <div *ngIf="mdl_Request.get('bCargo')?.value" class="position-relative col-12 col-md-12 p-2">
    
                                <ng-container *ngIf="mdl_Request.get('bCargo')?.value">
                   
                                    <label class="mb-2 text-muted"> توضیحات بار </label>
                        
                                    <input class="form-control p-2 text-start" formControlName="strCargoDetail">
    
                                </ng-container>
                    
                            </div>

                        </ng-container>

                        <!-- دارای توقف -->

                        <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bHasStop')?.value || bEditMode != 'showMode'">

                            <div class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-12 p-2">

                                <input class="form-check-input m-0" type="checkbox" id="bHasStop" formControlName="bHasStop">
                            
                                <label class="form-check-label pointer text-muted me-2" for="bHasStop"> توقف دارد </label>
                            
                            </div>

                        </ng-container>

                        <!-- مدت توقف -->

                        <div *ngIf="mdl_Request.get('bHasStop')?.value" class="position-relative col-12 col-md-12 p-2">

                            <ng-container *ngIf="mdl_Request.get('bHasStop')?.value">

                                <label class="mb-2 text-muted"> مدت توقف </label>
                
                                <input class="form-control p-2"

                                    placeholder="مدت زمان توقف را وارد کنید مانند : 2.5 ساعت"

                                    [ngClass]="mdl_Request.get('fEstimateStop')?.value != '' ? 'text-center' : 'text-start'"

                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                
                                    formControlName="fEstimateStop">

                            </ng-container>
                                
                        </div>

                        <!-- رفت و برگشت -->

                        <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bCameBack')?.value || bEditMode != 'showMode'">

                            <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                                <input class="form-check-input m-0" type="checkbox" id="bCameBack" formControlName="bCameBack">
                            
                                <label class="form-check-label pointer text-muted me-2" for="bCameBack"> رفت و برگشت </label>
                            
                            </div>

                        </ng-container>

                        <!-- حیوان خانگی دارد -->

                        <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bPet')?.value || bEditMode != 'showMode'">

                            <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                                <input class="form-check-input m-0" type="checkbox" id="bPet" formControlName="bPet">
                            
                                <label class="form-check-label pointer text-muted me-2" for="bPet"> حیوان خانگی دارد </label>
                            
                            </div>

                        </ng-container>

                        <!-- سیگار مجاز -->

                        <ng-container *ngIf="!isCity">

                            <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bSmoking')?.value || bEditMode != 'showMode'">

                                <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                                    <input class="form-check-input m-0" type="checkbox" id="bSmoking" formControlName="bSmoking">
                                
                                    <label class="form-check-label pointer text-muted me-2" for="bSmoking"> سیگار مجاز </label>
                                
                                </div>

                            </ng-container>

                        </ng-container>

                        <!-- مسافر نیاز به کمک دارد -->

                        <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bNeedHelp')?.value || bEditMode != 'showMode'">

                            <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                                <input class="form-check-input m-0" type="checkbox" id="bNeedHelp" formControlName="bNeedHelp">
                            
                                <label class="form-check-label pointer text-muted me-2" for="bNeedHelp"> مسافر نیاز به کمک دارد </label>
                            
                            </div>

                        </ng-container>

                        <!-- تاکسی بین شهری -->

                        <ng-container *ngIf="!isCity">

                            <!-- متقاضی فاکتور -->

                            <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bInvoiceRequired')?.value || bEditMode != 'showMode'">

                                <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">
    
                                    <input class="form-check-input m-0" type="checkbox" id="bInvoiceRequired" formControlName="bInvoiceRequired">
                                
                                    <label class="form-check-label pointer text-muted me-2" for="bInvoiceRequired"> متقاضی فاکتور </label>
                                
                                </div>
    
                            </ng-container>

                            <!-- نام شرکت -->

                            <div *ngIf="mdl_Request.get('bInvoiceRequired')?.value" class="position-relative col-12 p-2">
                    
                                <label class="mb-2 text-muted"> نام شرکت </label>
                    
                                <input placeholder="جهت صدور فاکتور نام شرکت مورد نظر را وارد کنید" class="form-control p-2 text-start" formControlName="strCompany">
                    
                            </div>

                            <!-- مسافر غیر ایرانی -->

                            <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bForeigner')?.value || bEditMode != 'showMode'">

                                <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                                    <input class="form-check-input m-0" type="checkbox" id="bForeigner" formControlName="bForeigner">
                                
                                    <label class="form-check-label pointer text-muted me-2" for="bForeigner"> مسافر غیر ایرانی </label>
                                
                                </div>

                            </ng-container>
                            
                            <!-- شماره پاسپورت -->

                            <div *ngIf="mdl_Request.get('bForeigner')?.value" class="position-relative col-12 p-2">
                    
                                <label class="mb-2 text-muted"> شماره پاسپورت </label>
                    
                                <input placeholder="شماره پاسپورت مسافر غیر ایرانی را وارد کنید" class="form-control p-2 text-start" formControlName="strPassportNumber">
                    
                            </div>

                        </ng-container>

                        <!-- عدم نمایش کرایه  -->

                        <ng-container *ngIf="!isCity">

                            <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bHiddenFare')?.value || bEditMode != 'showMode'">

                                <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                                    <input class="form-check-input m-0" type="checkbox" id="bHiddenFare" formControlName="bHiddenFare">
                                
                                    <label class="form-check-label pointer text-muted me-2" for="bHiddenFare"> عدم نمایش کرایه  </label>
                                
                                </div>

                            </ng-container>

                        </ng-container>
                                                
                        <!-- گروه خودرویی -->

                        <div [ngClass]="mdl_Request.get('_fKm')?.value != '' || bEditMode ? 'col-md-4' : 'col-md-6' " class="position-relative col-12 p-2">
                
                            <label class="mb-2 text-muted"> گروه خودرویی </label>
                
                            <select class="form-select p-2" formControlName="tiMobileGroup" (change)="reset_calc()">
                
                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_GroupCar" [value]="item.tiMobileGroup">

                                    {{item.strComment}}
                
                                </option>
                
                            </select>
                
                        </div>

                        <!-- مبلغ -->

                        <div [ngClass]="mdl_Request.get('_fKm')?.value != '' || bEditMode ? 'col-md-4' : 'col-md-6' " class="position-relative col-12 p-2">
                
                            <label class="mb-2 text-muted"> مبلغ(ریال) </label>
                
                            <input class="form-control p-2 text-center"
                            
                                oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()
                                    
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')"

                                [value]="putSeprator(mdl_Request.get('iEstimateRent')?.value,bEditMode) "

                                formControlName="iEstimateRent">

                            <ng-container *ngIf="bEditMode != 'showMode'">

                                <button class="btn btn-primary rounded" (click)="calc_Renting()">

                                    <i class="fa fa-calculator fa-lg" aria-hidden="true"></i>
                                
                                </button>

                            </ng-container>

                
                        </div>

                        <!-- مسافت -->

                        <ng-container *ngIf="mdl_Request.get('_fKm')?.value != ''">

                            <div class="position-relative col-12 col-md-4 p-2" style="pointer-events: none;">
                
                                <label class="mb-2 text-muted"> مسافت </label>
                    
                                <input class="form-control p-2 text-center" formControlName="_fKm">
                    
                            </div>

                        </ng-container>

                        <!-- مدت -->

                        <ng-container *ngIf="mdl_Request.get('_fKm')?.value != ''">

                            <div class="position-relative col-12 col-md-4 p-2" style="pointer-events: none;">
                
                                <label class="mb-2 text-muted"> مدت </label>
                    
                                <input class="form-control p-2 text-center" formControlName="_strTime">
                    
                            </div>

                        </ng-container>

                        <!-- درصد کمسیون -->

                        <ng-container *ngIf="mdl_Request.get('_fKm')?.value != '' || bEditMode">

                            <div class="position-relative col-12 col-md-4 p-2">
                
                                <label class="mb-2 text-muted"> درصد کمسیون </label>
                    
                                <input class="form-control p-2 text-center" formControlName="tiCommissionPercentage">
                    
                            </div>

                        </ng-container>

                        <!-- مقدار پیش پرداخت -->

                        <ng-container *ngIf="mdl_Request.get('_fKm')?.value != '' || bEditMode">

                            <div class="position-relative col-12 col-md-4 p-2">
                
                                <label class="mb-2 text-muted"> مقدار پیش پرداخت </label>
                    
                                <input class="form-control p-2 text-center" formControlName="iAdvancePayment">
                    
                            </div>

                        </ng-container>

                        <!-- توضیحات -->
                
                        <div class="position-relative col-12 p-2">
                
                            <label class="mb-2 text-muted"> توضیحات </label>
                
                            <textarea style="height: 48px;resize: none;" class="form-control" formControlName="strComment"></textarea>
                
                        </div>

                        <!-- مشخصات راننده -->

                        <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('strUnitID')?.value != ''">

                            <!-- شناسه خودرو -->

                            <div class="position-relative col-12 col-md-3 p-2">
                    
                                <label class="mb-2 text-muted"> شناسه خودرو </label>
                    
                                <input class="form-control p-2 text-center" formControlName="strUnitID">
                    
                            </div>

                            <!-- نام راننده -->

                            <div class="position-relative col-12 col-md-3 p-2">
                    
                                <label class="mb-2 text-muted">نام راننده </label>
                    
                                <input class="form-control p-2 text-center" formControlName="strDriver_FullName">
                    
                            </div>

                            <!--  موبایل راننده -->

                            <div class="position-relative col-12 col-md-3 p-2">
                    
                                <label class="mb-2 text-muted"> موبایل راننده </label>
                    
                                <input class="form-control p-2 text-center" formControlName="strDriver_Mobile">
                    
                            </div>

                        </ng-container>
                
                    </div>
    
                </div>
    
                <div *ngIf="bEditMode != 'showMode'" class="modal-footer d-flex justify-content-start">

                    <!-- ثبت -->
    
                    <button [ngClass]="bEditMode == true ? 'btn-primary' : 'btn-success' " class="btn" (click)="submit_Request()">
    
                        &nbsp; &nbsp; {{ bEditMode == true ? 'ویرایش' : 'ثبت'  }} &nbsp; &nbsp;
    
                    </button>

                    <!-- بازنشانی فرم -->

                    <button class="btn btn-outline-danger" (click)="reset_Form()">
    
                        &nbsp; &nbsp; بازنشانی فرم &nbsp; &nbsp;
    
                    </button>

                    <!-- بستن -->
    
                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal" (click)="closeModal()">
    
                        &nbsp; بستن &nbsp;
    
                    </button>
    
                </div>
    
            </div>
    
        </div>
    
</div>
